enum Gender {
  Male = 'Male',
  Female = 'Female',
  Unknown = 'Unknown',
}

export default Gender;
